import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 查询班级列表
export function queryClazzList(data) {
    return http.request({
        url: common.url + '/papi/clazz/list',
        method: 'get',
        params: data
    })
}

// 提交学习记录到住建厅证书
export function submitStudyHonours(data) {
    return http.request({
        url: common.url + '/papi/cert_record/addCertRecord',
        method: 'get',
		params: data
    })
}

//查询学员证书提交记录
export function getUserCertRecordList(data) {
    return http.request({
        url: common.url + '/papi/cert_record/getUserCertRecordList',
        method: 'get',
        params: data
    })
}

// 提交学习记录到住建厅证书
export function submitStudyHonours2(data) {
    return http.request({
        url: common.url + '/papi/clazz/submitStudyHonours',
        method: 'get',
		params: data
    })
}

//报班
export function startReport(data) {
    return http.request({
        url: common.url + '/papi/user_clazz/startReport',
        method: 'get',
        params: data
    })
}

//取消报班计划
export function cancelClazzStudentById(id) {
    return http.request({
        url: common.url + '/papi/user_clazz/cancelClazzStudentById/' + id,
        method: 'get'
    })
}

//查询班级详情
export function queryClazzById(data) {
    return http.request({
        url: common.url + '/papi/clazz/queryClazzById',
        method: 'get',
        params: data
    })
}

// 查询班级列表
export function queryMyClassList() {
    return http.request({
        url: common.url + '/papi/clazz/queryMyClassList',
        method: 'get'
    })
}

// 数据提交
export function queryJxjy() {
    return http.request({
        url: common.url + '/papi/clazz/queryJxjy',
        method: 'get'
    })
}